import { createApp } from 'vue'
import App from './App.vue'

// App main
const main = async () => {
  let componentContainer = document.getElementById('componentContainer')
  if (componentContainer) {
    const app = createApp(App)
    app.mount('#componentContainer')
  }
}

// Execute async function
main().then((root) => {})

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
